<mat-dialog-content class="sign-request-path-dialog__content">
  <button
    type="button"
    mat-icon-button
    class="sign-request-path-dialog__close"
    (click)="close()"
    [attr.aria-label]="'close' | translate">
    <mat-icon>close</mat-icon>
  </button>
  <h2 class="sign-request-path-dialog__title">{{ 'signRequestPathTitle' | translate }}</h2>

  <div class="sign-request-path-dialog__options">
    <button
      type="button"
      class="sign-request-path-dialog__card sign-request-path-dialog__card--send"
      (click)="choose('sendForESignature')">
      <span class="sign-request-path-dialog__icon-wrap sign-request-path-dialog__icon-wrap--send">
        <img
          src="assets/sendiocn.png"
          alt=""
          class="sign-request-path-dialog__icon-img sign-request-path-dialog__icon-img--send" />
      </span>
      <span class="sign-request-path-dialog__label">{{ 'signRequestPathSendTitle' | translate }}</span>
      <span class="sign-request-path-dialog__hint">{{ 'signRequestPathSendHint' | translate }}</span>
    </button>

    <button
      type="button"
      class="sign-request-path-dialog__card sign-request-path-dialog__card--self"
      (click)="choose('selfSign')">
      <span class="sign-request-path-dialog__icon-wrap sign-request-path-dialog__icon-wrap--self">
        <img
          src="assets/create-request_icon.png"
          alt=""
          class="sign-request-path-dialog__icon-img sign-request-path-dialog__icon-img--self" />
      </span>
      <span class="sign-request-path-dialog__label">{{ 'signRequestPathSelfSignTitle' | translate }}</span>
      <span class="sign-request-path-dialog__hint">{{ 'signRequestPathSelfSignHint' | translate }}</span>
    </button>
  </div>
</mat-dialog-content>
